export const DOMAIN_REGEX = /^(?:www\.)?(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/i